exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.row-pointer[data-v-f1dc2d6c] {\n  cursor: pointer;\n}\n.fine-tune-font[data-v-f1dc2d6c] {\n  font-size: 14px;\n}\n", ""]);
